module.exports = __webpack_public_path__ + "img/business_people.edb0e138.png";